<template>
  <div class="fonts-display d-flex flex-column i-p-10">
    <div class="title d-flex flex-row i-gap-6 i-mb-9">
      <div class="text flex-column align-items-start flex-grow-1">
        <div class="name i-text-button-2 i-text-neutral-120">
          All document Fonts
        </div>
        <div class="subtitle i-text-body-3 i-text-neutral-110">
          List of document fonts
        </div>
      </div>
    </div>

    <i-spinner v-if="documentFontsMetadata.isLoading"></i-spinner>
    <div
      v-else-if="documentFontsMetadata.length === 0"
      class="i-text-neutral-120 i-text-subheading-3"
    >
      No fonts were found in this document
    </div>
    <div v-else class="fonts-list" data-testid="fonts-table">
      <div
        v-for="font in documentFontsMetadata.fonts"
        :key="font.name"
        class="font d-flex align-items-center i-text-neutral-120 i-text-subheading-3 i-py-3"
      >
        {{ font.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { iSpinner } from '@inscribe/signal';

export default {
  components: { iSpinner },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    documentFontsMetadata() {
      return this.$store.state.documentFontsMetadata;
    },
  },
  mounted() {
    this.getDocumentFontsMetadata();
  },
  methods: {
    getDocumentFontsMetadata() {
      this.$store.commit('setFontsMetadataLoading', true);
      this.$store
        .dispatch('getFontsMetadata', {
          customerId: this.document.customer_id,
          documentId: this.document.id,
        })
        .then(() => {
          this.$store.commit('setFontsMetadataLoading', false);
        });
    },
  },
};
</script>

<style lang="scss">
.fonts-display {
  max-height: 100%;
  width: 100%;

  .fonts-list {
    width: 100%;

    .font {
      width: 100%;
      height: 40px;
      border-bottom: 0;

      &:not(:last-of-type) {
        border-bottom: 1px solid $light-neutral-60;
      }
    }
  }
}
</style>
